// extracted by mini-css-extract-plugin
export default {"modalWidth":"ModalController_modalWidth__YKsfU","handle":"ModalController_handle__QGzgE"};